import React from "react";
import {
  Box,
  CardHeader,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Card, CardContent } from "../../components/Card";
import { useAlert } from "../../components/Alert";
import Text from "../../components/Text";
import "../../wrap.css";
import Button from "../../components/Button";

export default function PointsStoreTable() {
  const Alert = useAlert();
  const useStyles = makeStyles({
    DocumentContainerCenter: {
      display: "flex",
      justifyContent: "center",
    },
  });
  const classes = useStyles();
  const pointsList = [
    { point: "100", price: "2" },
    { point: "500", price: "1.5" },
    { point: "1000", price: "1.4" },
    { point: "3000", price: "1.2" },
    { point: "5000", price: "1.1" },
    { point: "10000", price: "1" },
  ];
  return (
    <>
      <Card>
        <Grid item container justify="center">
          <CardHeader title={"購買說明"} style={{ color: "#ff1744" }} />
        </Grid>
        <CardContent style={{ display: "flex" }}>
          <Grid container item sm={6} justify="center">
            <Typography className="msg-wrapper">
              {"1.選擇點數種類" +
                "\n" +
                "2.點選圖片進入刷卡頁面" +
                "\n" +
                "3.依提示填寫資料後按下'安全付款'按鈕" +
                "\n" +
                "4.出現'交易完成'的提示前請勿關閉視窗" +
                "\n" +
                "5.交易完成後查看歷史紀錄，確認點數是否入帳" +
                "\n" +
                "6.網頁上方的剩餘點數為交易前的資料，按一下首頁的按鈕即可刷新"}
            </Typography>
          </Grid>
          <Grid container item sm={6} justify="center">
            <Typography className="msg-wrapper">
              {"或以銀行匯款" +
                "\n" +
                "受款銀行名稱：永豐商業銀行807" +
                "\n" +
                "分支單位：南台中分行" +
                "\n" +
                "收款人帳號：038-001-0001236-5" +
                "\n" +
                "收款人戶名：富屋實業有限公司" +
                "\n" +
                "*匯款後請通知(04)24717673 行政部"}
            </Typography>
          </Grid>
        </CardContent>
      </Card>
      {"\u2002"}
      <Grid container spacing={2} direction="row">
        {pointsList.map((item) => {
          return (
            <Grid
              container
              item
              sm={4}
              classes={{ root: classes.DocumentContainerCenter }}
            >
              <Card>
                <CardContent style={{ marginTop: "8px" }}>
                  <div
                    style={{
                      height: 30,
                      width: 250,
                      backgroundColor: "#2b3968",
                      borderRadius: "5px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 17,
                    }}
                  >
                    {item.point + "點"}
                  </div>
                  <Typography className="msg-wrapper">
                    {"可發送" +
                      item.point +
                      "則簡訊" +
                      "\n" +
                      "每1則簡訊" +
                      item.price +
                      "元"}
                  </Typography>
                  <Grid container justify="space-between" alignItems="flex-end">
                    <Text type="h4">
                      {"$" + Number(item.point) * Number(item.price) + "元"}
                    </Text>
                    <Button
                      style={{ color: "white", backgroundColor: "#2b3968" }}
                      onPress={() => {
                        Alert.alert(
                          "選擇的點數為" +
                            item.point +
                            "點\u2002" +
                            "價格為" +
                            Number(item.point) * Number(item.price)+"元",
                          "確定要購買？",
                          [
                            {
                              text: "確定",
                              // onPress: () =>
                              //   hideAnswer({
                              //     variables: { id: Number(item.id) },
                              //   }),
                              type: "ok",
                            },
                            {
                              text: "取消",
                              type: "cancel",
                            },
                          ]
                        );
                      }}
                    >
                      購買
                    </Button>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
        <div
          className="msg-wrapper"
          style={{
            height: 80,
            width: "100%",
            backgroundColor: "#333333",
            borderRadius: "5px",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {"\u2002\u2002\u2002\u2002\u2002\u2002\u2002\u2002\u2002富屋企業集團法拍屋連鎖加盟總部。富屋地政士事務所。富屋專業法拍屋。富屋數位房訊" +
            "\n" +
            "總部地址：台中市南屯區大英西一街61號。熱線(04)24717673。FAX：(04)24757108。客服中心：(04)24720443"}
        </div>
      </Grid>
    </>
  );
}
